import { render, staticRenderFns } from "./CapturaHuella.vue?vue&type=template&id=12a298d4"
import script from "./CapturaHuella.vue?vue&type=script&lang=js"
export * from "./CapturaHuella.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports